import generateTimePicker from "src/decidim/datepicker/generate_timepicker";
import { formatInputTime } from "src/decidim/datepicker/datepicker_functions";
import { getDictionary } from "src/decidim/i18n";
export default function formTimePicker(input) {
  if (!input || input.type !== "time") return;
  const i18nTime = getDictionary("time");
  const i18nTimeHelp = getDictionary("time.formats.help");
  const formats = { time: i18nTime.clock_format || 24 };
  if (!input.id) {
    input.id = "demo-timepicker";
  }
  input.style.display = "none";
  const label = input.closest("label");
  label.classList.add("datepicker__input-label");
  const row = document.createElement("div");
  row.setAttribute("id", `${input.id}_timepicker_row`);
  row.setAttribute("class", "datepicker__timepicker-row");
  const timeColumnWrapper = document.createElement("div");
  timeColumnWrapper.setAttribute("id", `${input.id}_time-column-wrapper`);
  timeColumnWrapper.setAttribute("class", "datepicker__time-column-wrapper");
  row.append(timeColumnWrapper);
  if (label) {
    label.classList.add("datepicker__input-label");
    label.parentElement.insertBefore(row, label);
    timeColumnWrapper.insertBefore(label, timeColumnWrapper.firstChild);
  } else {
    input.after(row);
  }
  const timepickerContainer = generateTimePicker(input, timeColumnWrapper, formats);
  if (input.placeholder) {
    const timeTextInput = timepickerContainer.querySelector(`#${input.id}_time`);
    if (timeTextInput) {
      timeTextInput.placeholder = input.placeholder;
    }
  }
  if (!input.getAttribute("hide_help")) {
    const timeHelpTextContainer = document.createElement("div");
    timeHelpTextContainer.setAttribute("class", "datepicker__help-text-container flex gap-[0.5rem]");
    const helpTextTime = document.createElement("span");
    helpTextTime.setAttribute("class", "help-text datepicker__help-time");
    helpTextTime.innerText = i18nTimeHelp.time_format;
    timeHelpTextContainer.appendChild(helpTextTime);
    timeColumnWrapper.insertBefore(timeHelpTextContainer, timeColumnWrapper.firstElementChild.nextElementSibling);
  }
  if (formats.time === 12) {
    const am = document.getElementById(`period_am_${input.id}`);
    if (am) am.checked = true;
  }
  const form = timepickerContainer.closest("form");
  const isAbideForm = form && form.dataset.abide === "true";
  if (isAbideForm) {
    timepickerContainer.addEventListener("click", (event) => {
      var _a;
      if (!["datepicker__select-clock", "datepicker__reset-clock"].some(
        (className) => event.target.classList.contains(className)
      )) {
        return;
      }
      const timeInput = (_a = timepickerContainer.closest(".datepicker__time-column")) == null ? void 0 : _a.querySelector("input");
      if (timeInput) timeInput.dispatchEvent(new Event("change", { bubbles: true }));
    });
    $(form).foundation("_reflow", "abide");
  }
  const inputFieldValue = input.value;
  if (inputFieldValue !== "") {
    const timeInput = document.getElementById(`${input.id}_time`);
    if (timeInput) {
      timeInput.value = formatInputTime(inputFieldValue, formats.time, input);
    }
  }
  input.parentElement.querySelectorAll(".form-error").forEach((error) => {
    var _a;
    const timepickerRow = document.getElementById(`${input.id}_timepicker_row`);
    const timeColumn = timepickerRow == null ? void 0 : timepickerRow.querySelector(".datepicker__time-column");
    if (timeColumn) {
      const timepickerError = error.cloneNode(true);
      const innerInputId = (_a = timeColumn.querySelector("input")) == null ? void 0 : _a.id;
      if (innerInputId) timepickerError.setAttribute("data-form-error-for", innerInputId);
      timeColumn.parentElement.append(timepickerError);
    }
    error.remove();
  });
}
